import React from 'react';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';

import useUser from 'core/hooks/useUser';
import Header from 'core/ui/components/Header/Header';
import LogoutButton from 'core/ui/components/LogoutButton';
import { EXTERNAL_LINKS } from 'core/api/constants';
import { Text } from 'core/ui/atoms';
import { NavItem , MobileNavItem } from 'core/ui/atoms/V2';
import { isGuestEmail } from 'onramp/helpers';

import { ReactComponent as UserSVG } from 'core/assets/images/V2/icons/User.svg';

function OnrampHeader() {
  const { currentUser } = useUser();

  const LoginButton = (key) => {
    if (currentUser && !isEmpty(currentUser.email) && !isGuestEmail(currentUser.email)) {
      return (
        <LogoutButton reload={true} key={key}>Change Your Zipcode</LogoutButton>
      );
    } else {
      return (
        <NavItem to="/sign-in" activeClassName='hidden' key={key}>
          Log-In <SVGIcon />
        </NavItem>
      );
    }
  };

  const MobileLoginOptions = () => {
    if (!isEmpty(currentUser?.email) && isGuestEmail(currentUser?.email)) {
      return <MobileNavItem to="/sign-in" key="nav-sign-in">Log In</MobileNavItem>;
    } else {
      return (
        <MobileNavItem key="nav-programs"
          additionalComponent={
            <LogoutButton reload={true} textButton={true}>Log Out</LogoutButton>
          }
          subMenus={[
            { label: 'Weekly Menu', href: '/onramp/order-management' },
            { label: 'My Program', href: '/onramp/my-program' },
            { label: 'My Settings', href: '/onramp/my-settings' },
            { label: 'My Orders', href: '/onramp/order-history' },
            { label: 'My Invoices', href: '/onramp/my-invoices' },
            { label: 'Contact', href: '/onramp/order-management' },
          ]}>
          My Account
        </MobileNavItem>
      );
    }
  };

  const rightNavItems = () => {
    return [
      <NavItem key="nav-programs"
        subMenus={[{ label: 'Signature Program', href: EXTERNAL_LINKS.signatureProgram, target: '_blank' },
                   { label: 'Post Partum Haute Mom', href: EXTERNAL_LINKS.postPartumHauteMomProgram, target: '_blank' },
                   { label: 'Transformation Tribe', href: EXTERNAL_LINKS.transformationTribeProgram, target: '_blank' },
                  ]}>
        Our Programs
      </NavItem>,
      <NavItem href={EXTERNAL_LINKS.ourStory} key="nav-our-story" target='_blank'>Our Story</NavItem>,
      <LoginButton key="nav-sign-in" />,
    ];
  };

  const WelcomeNavItem = () => {
    if (currentUser && !isEmpty(currentUser.email) && !isGuestEmail(currentUser.email)) {
      return (<NameTitle>Welcome, {currentUser?.firstName} {currentUser?.lastName}</NameTitle>);
    }
    return [];
  };

  const mobileNavItems = () => {
    return [
      <WelcomeNavItem key="user-name" />,
      <MobileNavItem href='/onramp/init-order' key="nav-our-story">Home</MobileNavItem>,
      <MobileNavItem key="nav-programs"
        subMenus={[{ label: 'Signature Program', href: EXTERNAL_LINKS.signatureProgram, target: '_blank' },
                   { label: 'Post Partum Haute Mom', href: EXTERNAL_LINKS.postPartumHauteMomProgram, target: '_blank' },
                   { label: 'Transformation Tribe', href: EXTERNAL_LINKS.transformationTribeProgram, target: '_blank' },
                  ]}>
        Our Programs
      </MobileNavItem>,
      <MobileNavItem href={EXTERNAL_LINKS.ourStory} key="nav-our-story" target='_blank'>
        Our Story
      </MobileNavItem>,
      <MobileLoginOptions key='nav-account-option' />,
    ];
  };

  return (
    <Header rightNavItems={rightNavItems} mobileNavItems={mobileNavItems} />
  );
}

const SVGIcon = styled(UserSVG)`
  vertical-align: middle;
  margin-left: 0.3em;
`;

const NameTitle = styled(Text)`
  font-family: ${({ theme }) => theme.typography.familyLarken};
  font-weight: 400;
  font-size: 22px;
  line-height: 28px;
  letter-spacing: 0%;
  font-style: italic;
  color: ${({ theme }) => theme.colors.white};
`;

export default OnrampHeader;
